<template>
  <div id="app">
    <div
      id="head"
      :class="showBackground ? 'background' : ''"
      v-if="!showHeadandFoot"
    >
      <div class="head-box">
        <div class="logo">
          <img src="./assets/logo2.png" />
        </div>
        <div class="nav">
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#fff0"
            text-color="#fff"
            active-text-color="#5dacffdb"
            style="border-bottom: none"
            router
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/SoftwareProduct">软件产品</el-menu-item>
            <el-menu-item index="/HardwareProducts">硬件产品</el-menu-item>
            <el-menu-item index="/NewsAndInformation">新闻资讯</el-menu-item>
            <el-menu-item index="/ContactUs">关于我们</el-menu-item>
          </el-menu>
        </div>
        <el-dropdown trigger="click" class="cebian">
          <p class="el-dropdown-link">
            <img :src="imgPath" alt="" />
          </p>
          <el-dropdown-menu slot="dropdown" class="cebian-menu">
            <el-dropdown-item
              @click.native="goPage('/')"
              :class="activeIndex == '/' ? 'itemActive' : ''"
              >首页</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="goPage('/SoftwareProduct')"
              :class="activeIndex == '/SoftwareProduct' ? 'itemActive' : ''"
              >软件产品</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="goPage('/HardwareProducts')"
              :class="activeIndex == '/HardwareProducts' ? 'itemActive' : ''"
              >硬件产品</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="goPage('/NewsAndInformation')"
              :class="activeIndex == '/NewsAndInformation' ? 'itemActive' : ''"
              >新闻资讯</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="goPage('/ContactUs')"
              :class="activeIndex == '/ContactUs' ? 'itemActive' : ''"
              >关于我们</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <router-view class="content" />
    <div class="anchorPoint" @click="backToTop" v-if="flag_scroll">
      <img src="@/assets/arrow.png" />
    </div>
    <div class="foot" v-if="!showHeadandFoot">
      <div>
        <span>
          <i class="el-icon-location-outline"></i>珠海市兰埔富华里中海大厦B座304
        </span>
        <span><i class="el-icon-phone"></i>0756-8598915</span>
        <span><i class="el-icon-message"></i>zhhaorui@163.com</span>
      </div>
      <div>
        <span style="cursor: pointer">
          珠海灏睿科技有限公司 版权所有
          <span style="font-size: 15px">©</span> 珠海灏睿科技有限公司
        </span>
        <span style="cursor: pointer" @click="openPrivacyPolicy">
          隐私权政策
        </span>
        <span>
          <a
            style="color: #fff"
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049002000767"
          >
            <p
              style="
                display: flex;
                justify-content: center;
                align-items: flex-end;
              "
            >
              <img src="@/assets/gwablogo.png" />
              <span>粤公网安备 44049002000767号</span>
            </p>
          </a>
        </span>
        <span>
          <a
            href="http://beian.miit.gov.cn"
            target="_blank"
            style="color: white"
            >粤ICP备20058911号
          </a>
        </span>
      </div>
      <!-- <div class="foot-box">
        <div class="float-left">
          <div>
            <div>
              <i class="el-icon-location-outline"></i
              >珠海市兰埔富华里中海大厦B座304
            </div>
            <div><i class="el-icon-phone"></i>0756-8598915</div>
            <div><i class="el-icon-message"></i>zhhaorui@163.com</div>
          </div>
          <div>
            <div style="cursor: pointer">
              珠海灏睿科技有限公司 版权所有 @ 珠海灏睿科技有限公司
            </div>
            <div style="cursor: pointer" @click="openPrivacyPolicy">
              隐私权政策
            </div>
          </div>
        </div>
        <div class="float-right">
          <a
            style="color: black"
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049002000767"
          >
            <p style="display: flex; align-items: center">
              <img src="@/assets/gwablogo.png" />
              <span>粤公网安备 44049002000767号</span>
            </p>
          </a>
          <a
            href="http://beian.miit.gov.cn"
            target="_blank"
            style="color: white"
            >粤ICP备20058911号
          </a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeIndex: this.$route.path,
      imgPath: require("./assets/menu.png"),
      flag_scroll: false,
      scroll: 0,
      showBackground: false,
      showHeadandFoot: false,
    };
  },
  components: {},
  computed: {
    ...mapState(["isNative"]),
  },
  watch: {
    $route() {
      // console.log("路由变化了");
      // console.log("当前页面路由：" + to.path);
      // console.log("上一个路由：" + from);
      // this.backToTop();
      document.documentElement.scrollTop = 0;
    },
    isNative(newVal) {
      this.showHeadandFoot = newVal;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true); //移除监听事件
  },
  methods: {
    goPage(routerName) {
      // console.log("goPage");
      this.activeIndex = routerName;
      // console.log("activeIndex", this.activeIndex);
      this.$router.push(routerName);
    },
    openPrivacyPolicy() {
      this.$router.push("privacyPolicy");
    },
    backToTop() {
      //回到顶部方法 点击按钮调用
      let top = document.documentElement.scrollTop;
      // 实现滚动效果，缓慢回到顶部
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 10);
    },
    //滑动超过200时显示按钮
    handleScroll() {
      // console.log(document.documentElement.scrollTop);
      let scrollTop = document.documentElement.scrollTop;
      // console.log(scrollTop);
      if (scrollTop > 300) {
        this.flag_scroll = true;
      } else {
        this.flag_scroll = false;
      }
      if (scrollTop > 0) {
        this.showBackground = true;
      } else {
        this.showBackground = false;
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 2560px;
  min-height: 100vh;
  overflow-x: hidden;
  margin: 0 auto;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
* {
  padding: 0;
  margin: 0;
}
.el-menu-item {
  font-size: 20px !important;
  font-weight: bold;
}
.el-menu-item:hover {
  background-color: #fff0 !important;
  color: #409eff !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}
.itemActive {
  background-color: #ecf5ff !important;
  color: #66b1ff !important;
}
#head {
  width: 100%;
  padding: 15px 50px;
  // background: #00000042;
  background: linear-gradient(#00000072, #00000042, #fff0);
  overflow: hidden;
  position: fixed;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  .head-box {
    width: 100%;
    max-width: 2560px;
    margin: 0 auto;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .logo {
      width: 200px;
      height: 66px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .cebian {
      display: none;
      float: right;
      .el-dropdown-link {
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
.background {
  background: #000000ab !important;
}
// .content {
//   margin-top: 90px;
// }
.anchorPoint {
  width: 42px;
  height: 62px;
  position: fixed;
  right: calc(5%);
  bottom: 150px;
  background: #bababa;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  opacity: 0.8;
  cursor: pointer;
  z-index: 999;
  img {
    width: 80%;
  }
}
.foot {
  width: 100%;
  margin-top: auto;
  background: rgb(44, 44, 44);
  color: white;
  padding: 10px 0;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    > span {
      padding: 5px 10px;
      i {
        margin-right: 2px;
      }
    }
  }
  a {
    display: inline-block;
  }
  // > .foot-box {
  //   width: 80%;
  //   height: 120px;
  //   margin: auto;
  //   > .float-left {
  //     float: left;
  //     > div:nth-child(1) {
  //       font-size: 15px;
  //       line-height: 20px;
  //       margin-bottom: 10px;
  //       > div {
  //         margin-bottom: 5px;
  //         > i {
  //           margin-right: 5px;
  //         }
  //       }
  //     }
  //     > div:nth-child(2) {
  //       font-weight: 100;
  //       font-size: 12px;
  //       line-height: 20px;
  //     }
  //   }
  //   > .float-right {
  //     float: right;
  //     font-size: 12px;
  //     height: 120px;
  //     line-height: 20px;
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: flex-end;
  //     img {
  //       width: 15px;
  //     }
  //     > a :nth-child(1) {
  //       > p {
  //         display: flex;
  //         align-items: center;
  //       }
  //     }
  //     > a {
  //       color: white;
  //       > p {
  //         color: white;
  //       }
  //     }
  //   }
  // }
}

@media screen and (max-width: 880px) {
  #head {
    padding: 15px 20px;
    .head-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        float: left;
        width: 150px;
        height: 50px;
        img {
          width: 100%;
        }
      }
      .nav {
        display: none;
      }
      .cebian {
        display: block;
        .el-dropdown-link {
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
  .foot {
    font-size: 13px;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
}
</style>
